<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-target`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c11.815 0 21.455 9.314 21.978 21h-4.005C41.454 13.524 33.606 6 24 6 14.059 6 6 14.059 6 24c0 9.83 7.88 17.82 17.67 17.997L24 42v4C11.85 46 2 36.15 2 24S11.85 2 24 2zm1.525 19.954l9.313 9.314h7.415v4h-3.415l2.95 2.95-2.828 2.828-2.95-2.95v3.414h-4v-7.414l-9.313-9.313 2.828-2.829zM34.955 23C34.45 17.394 29.738 13 24 13c-6.075 0-11 4.925-11 11s4.925 11 11 11v-4l-.24-.004A7 7 0 1130.93 23h4.025z"/></svg>
</template>
<script>

export default {
  name: 'IconTarget',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
